import React,{useState,useMemo} from 'react';
import Modal from '@material-ui/core/Modal';
import {Tools} from './Tools';
import Header from './Header';
import Top from "./Top";
import Edit from "./Edit";
import Board from "./Board";
import Yesno from "./Yesno";
import Guide from "./Guide";
import Result from "./Result";
import Archive from './Archive';
import Record from './Record';
import Search from './Search';
import {Inc} from "./Inc";
import "./Main.scss";

interface Props {
    uid:string,
    gid:string,
    clear():void,
    save(id?:string):void,
    mode?:string
}


const Main = (props:Props)=> {
    let mode = "top";
    if( props.mode ){
        mode = props.mode;
    } else if( props.gid!=="" ){
        mode = "record";
    }
    const [states,setStates] = useState({
        mode: mode,
        isModal: false,
        isYesno: false,
        next: "",
        result:Inc.defaultResultSet(),
    });

    const move = (newMode:string,param?:any) =>{
        if( param ){
            setStates({...states,mode:newMode,result:param});
        } else if(newMode==="edit") {
            setStates({...states,mode:newMode,result:Inc.defaultResultSet()});
        } else {
            setStates({...states,mode:newMode});
        }
    }

    const goTop = ()=>{
        if(states.mode!=="board" && states.mode!=="edit"){
            setStates({...states,mode:"top"});
        } else {
            setStates({...states,isYesno:true,next:"top"});
        }
    }
  
    const goGuide = ()=>{
        setStates({...states,isModal:true});
    }

    const goArchive = ()=>{
        if(states.mode!=="board" && states.mode!=="edit"){
            setStates({...states,mode:"archive"});
        } else {
            setStates({...states,isYesno:true,next:"archive"});
        }        
    }

    const handleModalClose = ()=>{
        setStates({...states,isModal:false});
    }

    const yes = ()=>{
        setStates({...states,mode:states.next,next:"",isYesno:false});
    }

    const no = ()=>{
        setStates({...states,isYesno:false});
    }

    const isAuth = useMemo( ()=>{
		if( !props.uid ){
			return false;
		}
		if( props.uid.length<28 ){
			return false;
		}
		return true;
    },[props.uid]);

    //console.log("main_render",props.uid);

    return (
        <React.Fragment>
            <Header top={goTop} guide={goGuide} archive={goArchive} isAuth={isAuth}/>

        {states.mode==="top" &&
            <Top uid={props.uid} isAuth={isAuth} move={move} save={props.save}/>
        }
        {states.mode==="edit" &&
            <Edit uid={props.uid} move={move} save={props.save} story={states.result.story}/>
        }
        {states.mode==="board" &&
            <Board uid={props.uid} move={move} save={props.save} story={states.result.story} play={states.result.play}/>
        }
        {states.mode==="archive" &&
            <Archive uid={props.uid} move={move} save={props.save}/>
        }
        {states.mode==="result" &&
            <Result uid={props.uid} move={move} result={states.result}/>
        }
        {states.mode==="record" &&
            <Record uid={props.uid} move={move} save={props.save} gid={props.gid}/>
        }
        {states.mode==="search" &&
            <Search uid={props.uid} move={move} save={props.save}/>
        }

            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={states.isModal}
                onClose={handleModalClose}
            >
                <div style={Tools.getModalStyle()} className="panel">
                    <Guide close={handleModalClose}/>
                </div>
            </Modal>
            <Yesno next={states.next} yes={yes} no={no} isOpen={states.isYesno}/>
        </React.Fragment>
	);
}

export default Main;
